import { Match, Schema } from 'effect';

import { BrandUuid } from '@vs-shop/schemas/product/filter/state/brand';
import { TaxonCode } from '@vs-shop/schemas/product/filter/state/taxon';

export const ListingScope = Schema.TaggedUnion({
  Taxon: { code: TaxonCode },
  Brand: { id: BrandUuid },
  Query: { text: Schema.String },
});

export type ListingScope = typeof ListingScope.Type;

/** The scalar identity used by listing atom families and client props. */
export const ListingScopeKey = Schema.String.pipe(Schema.brand('Listing.ScopeKey'));

export type ListingScopeKey = typeof ListingScopeKey.Type;

/** Creates the stable cache and atom-family identity for a listing scope. */
export const scopeKeyOf = (scope: ListingScope): ListingScopeKey =>
  ListingScopeKey.make(
    Match.value(scope).pipe(
      Match.tag('Taxon', ({ code }) => `taxon:${code}`),
      Match.tag('Brand', ({ id }) => `brand:${id}`),
      Match.tag('Query', ({ text }) => `query:${JSON.stringify(text)}`),
      Match.exhaustive
    )
  );
